import { Box, Typography, useTheme } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import { FormattedMessage } from "react-intl";

const SearchAiPlaceholder = ({ hasBriefData }: { hasBriefData: boolean }) => {
    const theme = useTheme();

    return hasBriefData ? (
        <Box
            sx={{
                p: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: theme.spacing(4),
                borderRadius: 1.5,
                backgroundColor: theme.palette.background.grey,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <CustomIcon icon={icons.documentLightBulb} sx={{ color: "#454852", fontSize: 20, mr: 1 }} />
                <CustomIcon icon={icons.thinArrowRight} sx={{ color: "#454852", fontSize: 26, mr: 1 }} />
                <CustomIcon icon={icons.flashLight} sx={{ color: "#454852", fontSize: 24, mr: 1 }} />
            </Box>
            <Typography sx={{ color: "#454852" }}>
                <FormattedMessage id="dashboard.searchAI.startSearch" />
            </Typography>
        </Box>
    ) : (
        <Box
            sx={{
                p: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: theme.spacing(4),
                borderRadius: 1.5,
                backgroundColor: theme.palette.background.grey,
            }}
        >
            <CustomIcon icon={icons.lock} sx={{ color: "#454852", fontSize: 20, mr: 1 }} />
            <Typography sx={{ color: "#454852" }}>
                <FormattedMessage id="dashboard.searchAI.completeInsights" />
            </Typography>
        </Box>
    );
};

export default SearchAiPlaceholder;
